import { createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from '../app/utilities/helpers.js';
import GetProxy from '../app/GetProxy.js';


const proxy = GetProxy();
const cookies = new Cookies();

// Generic API Request Wrapper

export const apiRequest = async ({ endpoint, payload, method = "POST" }) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");

  try {
    const response = await fetch(`${proxy}${endpoint}`, {
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "DTOP-API-TOKEN": apiToken,
        USERNAME: username,
      },
      body: method === "POST" ? JSON.stringify(payload || {}) : undefined,
    });

    handleResponseCode(response);


    const data = await response.json();
    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};


// Dynamic Thunk 

export const createDynamicThunk = (
  name,
  defaultEndpoint,
  paramKeys = [],
  method = "POST"
) =>
  createAsyncThunk(name, async (props = {}) => {
    const { payload = {}, endpoint, ...rest } = props;

    // If endpoint passed, use it, else fallback to default
    let finalEndpoint = endpoint ? `${defaultEndpoint}${endpoint}` : defaultEndpoint;

    if (paramKeys.length > 0) {
      // filter out "endpoint" because that's not a path param
      const pathKeys = paramKeys.filter((k) => k !== "endpoint");
      if (pathKeys.length > 0) {
        const pathParts = pathKeys.map((key) => rest[key]);
        finalEndpoint = `${finalEndpoint}/${pathParts.join("/")}`;
      }
    }

    return await apiRequest({ endpoint: finalEndpoint, payload, method });
  });



//  Reducer Case Helper

export const addApiCases = (builder, thunk, stateKey, isDelete = false) => {
  builder
    .addCase(thunk.pending, (state) => {
      state[`${stateKey}Loading`] = true;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        state[stateKey] = action.payload;
      } else {
        state[stateKey] = action.payload ?? [];
      }
    })
    .addCase(thunk.rejected, (state) => {
      state[`${stateKey}Loading`] = false;
      if (isDelete) {
        state.errorDelete = "Something went wrong";
      } else {
        state[stateKey] = [];
      }
    });
};



